import SubscribeContainer from './SubscribeContainer'

export default SubscribeContainer
